import { unsupportedMessageSelector } from "../../store/selectors/clientSettings";
import { useSelector } from 'react-redux';
export const UnsupportedPreview = ({
  type,
  default: defaultValue,
  value = defaultValue
}) => {
  const unsupportedMessage = useSelector(unsupportedMessageSelector);
  return <div className="foundry--surface surface--info field--unsupported--contents">
      <div className="alert--icon">
        <i className="foundry-icon icon--info icon--solid"></i>
      </div>
      <div>{`The ${type} ${unsupportedMessage}.`}</div>
    </div>;
};